import axios from "axios";
import { useEffect, useState } from "react";
import CustomPagination from "../../Utility/CustomPagination";

const RefundsTable = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;


  const fetchRefunds = async () => {
      setLoading(true);
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_BASE}/host/get-refund-transactions?page=${currentPage}&per_page=${limit}`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
        });
        setTransactions(Array.isArray(res?.data?.data) ? res.data.data : []);
        if (res.data.pagination) {
            setCurrentPage(res.data.pagination.current_page);
            setTotalPages(res.data.pagination.last_page);
          } else if (res.data.meta) {
            // in case your API uses "meta"
            setCurrentPage(res.data.meta.current_page);
            setTotalPages(res.data.meta.last_page);
          }
      } catch (err) {
        console.error("Error fetching refunds:", err);
      } finally {
        setLoading(false);
      }
    };


  useEffect(() => {
    
    fetchRefunds(currentPage);
  }, [currentPage]);

  const formatCurrency = (amount, currency = "USD") => {
  if (amount == null) return "—";

  // Default symbol mapping (you can add more as needed)
  const currencySymbols = {
    USD: "$",
    AUD: "$",
    EUR: "€",
    INR: "₹",
    GBP: "£",
  };

  const symbol = currencySymbols[currency] || "";

  // Format amount to 2 decimals
  const formattedAmount = parseFloat(amount).toFixed(2);

  return `${symbol} ${formattedAmount} ${currency}`;
};


  // const formatDate = (dateStr) => (dateStr ? new Date(dateStr).toLocaleDateString("en-GB") : "—");

  // ✅ Updated function to show both date & time
  const formatDateTime = (dateStr) => {
    if (!dateStr) return "—";
    const date = new Date(dateStr);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  if (loading) return <p className="text-center py-4">Loading refunds…</p>;
  if (!transactions.length) return <p className="text-center py-4">No refunds found.</p>;

  return (
    <div className="table-responsive">
      <table className="table table-condensed table-striped tbl_algn_ar">
        <thead>
          <tr>
            <th>Refund ID</th>
            <th>Date</th>
            <th>Amount</th>
            <th>Payment Method</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((tx) => {
            let statusLabel = "";
            let statusColor = "";

            switch (tx.status) {
              case 1:
                statusLabel = "Completed";
                statusColor = "green";
                break;
              case 0:
                statusLabel = "Pending";
                statusColor = "orange";
                break;
              case 2:
                statusLabel = "Cancelled";
                statusColor = "red";
                break;
              default:
                statusLabel = "Unknown";
                statusColor = "gray";
            }

            return (
              <tr key={tx.id}>
                <td>{tx.payment_id?.toUpperCase() || "—"}</td>
                <td>{formatDateTime(tx.updated_at)}</td>
                <td>{formatCurrency(tx.total_price, tx.currency)}</td>
                <td>{tx.payment_method || "—"}</td>
                <td style={{ color: statusColor, fontWeight: 600 }}>{statusLabel}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
<CustomPagination
                  currentPage={currentPage}
                  lastPage={totalPages}
                  onPageChange={handlePageChange}
                />

    </div>
  );
};

export default RefundsTable;
